module.exports = __webpack_public_path__ + "img/screenshot-device-empty.5d8ec2d4.jpg";